export function formatNumberTwoDigit(number) {
  if (number < 10) {
    return `0${number}`;
  }
  if (number < 100) {
    return number.toString();
  }
  return undefined;
}
